import React from 'react';
import { Stethoscope } from 'lucide-react';
import { BUSINESS_NAME, WA_LINK } from '../lib/constants';
export function Navbar() {
  return <header className="sticky top-0 z-40 w-full border-b border-slate-100 bg-white/80 backdrop-blur-md" data-id="element-97">
      <div className="container mx-auto flex h-20 items-center justify-between px-4 md:px-6" data-id="element-98">
        <div className="flex items-center gap-2 text-brand-dark" data-id="element-99">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-light text-brand-dark" data-id="element-100">
            <Stethoscope size={24} data-id="element-101" />
          </div>
          <span className="text-lg font-semibold tracking-tight md:text-xl" data-id="element-102">
            {BUSINESS_NAME}
          </span>
        </div>
        <nav className="hidden md:block" data-id="element-103">
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="rounded-full bg-brand-accent px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-brand-accentHover" data-id="element-104">
            Consultar ahora
          </a>
        </nav>
      </div>
    </header>;
}